import { ActionsObservable, ofType } from 'redux-observable';
import {
  ImageActionType,
  SetImageUploadProgressAction,
  UploadImageErrorAction,
  UploadImageRequestAction,
  UploadImageSuccessAction,
  setImageUploadProgress,
  uploadImageError,
  uploadImageSuccess,
} from '../../actions';
import { Observable, from } from 'rxjs';
import { mergeAll, switchMap } from 'rxjs/operators';
import { EpicDependencies } from '../epic-dependencies';
import { ImagesState } from '../../state/images';
import axios from 'axios';

export const uploadImageEpic = <
  A extends UploadImageRequestAction,
  S extends { images: ImagesState }
>(
  action$: ActionsObservable<A>,
  state: S,
  { client }: EpicDependencies,
): Observable<
  | UploadImageSuccessAction
  | UploadImageErrorAction
  | SetImageUploadProgressAction
> =>
  action$.pipe(
    ofType<UploadImageRequestAction>(ImageActionType.UploadRequest),
    switchMap(async action => {
      return new Observable<
        | UploadImageSuccessAction
        | UploadImageErrorAction
        | SetImageUploadProgressAction
      >(subscriber => {
        const data = new FormData();
        data.append('image', action.file);
        axios
          .post('/api/v0/images', data, {
            onUploadProgress: e => {
              subscriber.next(
                setImageUploadProgress(action.imageKey, e.loaded / e.total),
              );
            },
          })
          .then(res => {
            subscriber.next(
              uploadImageSuccess(action.imageKey, {
                id: res.data.id,
                url: res.data.url,
              }),
            );
          })
          .catch(error =>
            subscriber.next(uploadImageError(action.imageKey, error)),
          )
          .finally(() => subscriber.complete());
      });
    }),
    mergeAll(),
  );
